import { render, staticRenderFns } from "./OngoingCall.vue?vue&type=template&id=75dde94f&scoped=true&"
import script from "./OngoingCall.vue?vue&type=script&lang=js&"
export * from "./OngoingCall.vue?vue&type=script&lang=js&"
import style0 from "./OngoingCall.vue?vue&type=style&index=0&id=75dde94f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dde94f",
  null
  
)

export default component.exports